import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/site.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppStateProvider } from './state/AppStateProvider';
import { loadSiteConfig } from './configs/siteConfig';

// Business details (contact, hours, SEO) from Admin → Settings: the cached copy applies now, the API's on arrival.
loadSiteConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppStateProvider>
      <App />
    </AppStateProvider>
  </React.StrictMode>
);

// Performance monitoring
if (process.env.REACT_APP_ENABLE_ANALYTICS === 'true') {
  reportWebVitals(console.log);
}
